import { render, staticRenderFns } from "./EventoModule.vue?vue&type=template&id=2789ba96"
import script from "./EventoModule.vue?vue&type=script&lang=js"
export * from "./EventoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports